export default __webpack_public_path__ + "static/media/arrow-next.9146cef8.svg";